import api from "shared/api";
import { AxiosPromise } from "axios";

export interface Entry {
  id: number;
  type: string;
  description: string;
  relation_id: number;
  created_at: Date;
  user: {
    id: number;
    representee_id: number;
    first_name: string;
    last_name: string;
    organisation_name: string;
    email_address: string;
  };
}

export enum Type {
  Like = "like",
  Dislike = "dislike",
}

interface PostInitialFeedbackRequest {
  type: Type;
}

interface PostInitialFeedbackResponse {
  id: number;
  description_token: string;
  screenshot_token: string;
}

interface PostDescriptionRequest {
  token: string;
  description: string;
}

const prefix = "api/feedback";

export const postInitialFeedback = async (
  type: Type
): Promise<PostInitialFeedbackResponse> => {
  const data: PostInitialFeedbackRequest = { type };

  const res = await api().post<PostInitialFeedbackResponse>(
    `${prefix}/new`,
    data
  );
  return res.data;
};

export const postScreenshot = (
  token: string,
  id: number,
  file: Blob
): AxiosPromise<void> => {
  const formData = new FormData();
  formData.append("token", token);
  formData.append("screenshot", file, String(id) + ".png");

  return api().post(`${prefix}/${id}/screenshot`, formData, {
    headers: { "content-type": "multipart/form-data" },
  });
};

export const postDescription = (
  token: string,
  id: number,
  description: string
): AxiosPromise<void> => {
  const data: PostDescriptionRequest = { token, description };
  return api().post(`${prefix}/${id}/description`, data);
};

export const getFeedback = async (): Promise<Entry[]> => {
  const res = await api().get<Entry[]>(`${prefix}/list`);
  return res.data;
};

export const getScreenshotBlob = async (id: number): Promise<Blob> => {
  const res = await api().get<Blob>(`${prefix}/list/${id}/screenshot.png`, {
    responseType: "blob",
  });
  return res.data;
};
